export default __webpack_public_path__ + "static/media/bw-reaction-speed-tutorial-pop-up.2d440b60.svg";